<template>
  <div class="bnp" :class="`bnp--${banner.type}`" dir="rtl">
    <!-- Image (image / image_text) -->
    <div v-if="banner.type !== 'text'" class="bnp__media">
      <img v-if="banner.image_link" :src="banner.image_link" alt="" />
      <div v-else class="bnp__media-placeholder"><i class="pi pi-image"></i></div>
    </div>

    <!-- Text (text / image_text) -->
    <div v-if="banner.type !== 'image'" class="bnp__body">
      <h3 v-if="banner.title" class="bnp__title">{{ banner.title }}</h3>
      <p v-if="banner.description" class="bnp__desc">{{ banner.description }}</p>
      <span v-if="banner.button_text" class="bnp__cta">{{ banner.button_text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerCardPreview',
  props: { banner: { type: Object, required: true } },
};
</script>

<style scoped>
.bnp {
  display: flex; gap: 1rem; align-items: center; overflow: hidden;
  border-radius: 16px; background: linear-gradient(135deg, #eef2ff, #f5f3ff);
  border: 1px solid rgba(91,95,239,.14); min-height: 120px;
}
.bnp--text { padding: 1.4rem 1.6rem; }
.bnp--image { padding: 0; }
.bnp__media { flex: 0 0 42%; align-self: stretch; min-height: 120px; background: #e2e8f0; }
.bnp--image .bnp__media { flex: 1 1 100%; }
.bnp__media img { width: 100%; height: 100%; object-fit: cover; display: block; }
.bnp__media-placeholder { width: 100%; height: 100%; min-height: 120px; display: flex; align-items: center; justify-content: center; color: #94a3b8; font-size: 2rem; }
.bnp__body { flex: 1; padding: 1.2rem 1.4rem; min-width: 0; }
.bnp--image_text .bnp__body { padding-inline-start: 0; }
.bnp__title { font-size: 1.15rem; font-weight: 800; color: #111827; margin: 0 0 .4rem; }
.bnp__desc { font-size: .9rem; color: #4b5563; line-height: 1.6; margin: 0 0 .7rem; }
.bnp__cta { display: inline-block; background: #5B5FEF; color: #fff; padding: .45rem 1.1rem; border-radius: 10px; font-weight: 700; font-size: .85rem; }

@media (max-width: 640px) {
  .bnp { flex-direction: column; align-items: stretch; }
  .bnp__media { flex-basis: auto; }
}
</style>
